module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/home-saas-7ac5491b571013845733d52ce5ecf02f.png";